import styled from 'styled-components';
import ReactModal from 'react-modal';

export const StyledModalBody = styled.div`
  padding: var(--padding-base);
`;

export const StyledModalHeading = styled.div`
  padding: var(--padding-base) var(--padding-base) 0;
  display: flex;

  h2 {
    margin-bottom: 0;
  }
  button {
    margin-left: auto;
    background-color: transparent;
    border-color: transparent;
    color: var(--dark);
    cursor: pointer;
    font-size: 18px;
    margin-top: calc(var(--padding-base) * -1);
    text-transform: lowercase;
  }
`;

export const StyledReactModal = styled(ReactModal)`
  &.modal {
    border-top-style: solid;
    border-top-width: 10px;
    &_danger {
      border-color: var(--danger);
      ${StyledModalHeading} {
        color: var(--danger);
      }
    }
    &_success {
      border-color: var(--success);
      ${StyledModalHeading} {
        color: var(--success);
      }
    }
  }
`;
